import "../css/app.css";

import "./bootstrap";

import { GlobalStateProviders } from "@/Contexts/GlobalStateProviders";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";

import { captureFirstTouch } from "@/utils/activationSignals";
import { mobileAppSetup } from "@/utils/appCommunication";
import "@/utils/fun";
import "@/utils/openTabs";
import "@/utils/pageNavigationTracker";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

mobileAppSetup();
captureFirstTouch();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const page = await resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx"),
        );
        // @ts-expect-error The laravel-vite-plugin doesn't have types for page yet
        page.default.layout = (page) => (
            <GlobalStateProviders>{page}</GlobalStateProviders>
        );
        return page;
    },
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(<App {...props} />);
    },
    progress: {
        color: "#4B5563",
    },
});
